module.exports = __webpack_public_path__ + "img/kathrins.56c994f5.gif";